import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, catchError } from "rxjs";
import { Messages } from "../messages";
import { ApiEventStatus, ApiEventType } from "../models/api-event";
import { CountryTimeZoneDtoSchema } from "../models/dto/country-timezones.dto";
import { CountryDto } from "../models/dto/country.dto";
import { AbstractHttpHandler } from "./abstract-http-handler.service";
import { ApiEventService } from "./api-event.service";
import { AuthService } from "./auth-service";

@Injectable({
    providedIn: 'root',
})
export class CountryService extends AbstractHttpHandler{
    countries$ = new BehaviorSubject<Array<CountryDto>>([]);

    countryTimeZoneSchema$ = new BehaviorSubject<CountryTimeZoneDtoSchema>(undefined);

    constructor(
        public override http: HttpClient,
        public override apiEventsService: ApiEventService,
        private router: Router,
        private authService: AuthService ) {
        super(http, apiEventsService);
    }

    getCountries() {
        const url = `v2/countries`;
        const eventType = ApiEventType.GET_COUNTRIES;    
        this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.IN_PROGRESS, spinner: true });
        this.http.get<Array<CountryDto>>(url)
        .pipe(catchError(this.handleErrors(eventType, [])))
        .subscribe((response)=>{
            this.countries$.next(response);
            this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.COMPLETED, spinner: true });
        })
    }

    getCountryTimeZones(page:number = 1, 
                        limit:number = 10,
                        allowed: boolean = null,
                        countryId: number = null,
                        timeZoneId: number = null) {
        const url = `v2/countryTimeZones`;
        const eventType = ApiEventType.GET_COUNTRY_TIMEZONES;    
        this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.IN_PROGRESS, spinner: true });

        let params = new HttpParams();

           
        if(limit) {
          params = params.append('limit', limit);
        }            

        if(page) {
            params = params.append('page', page);
        }

        if(allowed !== null) {
            params = params.append('allowed', allowed);
        }

        if(countryId) {
            params = params.append('countryId', countryId);
        }

        if(timeZoneId) {
            params = params.append('timeZoneId', timeZoneId);
        }


        this.http.get<CountryTimeZoneDtoSchema>(url, {params})
        .pipe(catchError(this.handleErrors(eventType, [])))
        .subscribe((response)=>{
            this.countryTimeZoneSchema$.next(response);
            this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.COMPLETED, spinner: true });
        })
    }


    updateCountryTimezone(countryTimezoneId: number, allowed: boolean) {
        const url = `v2/countryTimeZones/${countryTimezoneId}`;
        const eventType = ApiEventType.UPDATE_COUNTRY_TIMEZONE;    
        this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.IN_PROGRESS, spinner: true });

        this.http.put(url, {}, {
            params: {
                allowed
            }
        })
        .pipe(catchError(this.handleErrors(eventType, [])))
        .subscribe((response)=>{
            this.apiEventsService.sendEvent({ type: eventType, status: ApiEventStatus.COMPLETED, spinner: true });
        })
    }


    protected handleErrors<T>(eventType: ApiEventType, response?: T): (error: any) => T {
        return (error: any): T => {
          const errorResponse = error.error;

          let title = Messages.HEADER_GENERIC_ERROR;
          let message = Messages.MESSAGE_GENERIC_ERROR;
          let showDialog = true;

          if (errorResponse) {
            const errorCode = errorResponse.error;
            switch (errorCode) {
              case 'invalid_token': {
                title = Messages.HEADER_EXPIRED_SESSION_ERROR;
                message = Messages.MESSAGE_EXPIRED_SESSION_ERROR;
                break;
              }

            }
         }
    
         const errorToken = error.headers.get('Response_token');
         message = `${message} <br/> Response Token: ${errorToken}`;
         
         this.apiEventsService.sendEvent({
                type: eventType,
                status: ApiEventStatus.ERROR,
                title,
                message,
                popup: showDialog 
          });

          this.unAuthorizedHandler(error)
          return response as T;
        };
    }

    protected unAuthorizedHandler(error:any) {
        if(error.status === 401) {
            this.clearLocalStorage();  
            this.router.navigate(['']);
        }
    }

}